import React, { useRef, useEffect } from 'react';
import './Helmet.scss';
import videomov from '../../../../assets/artemis/helmet/artemis_helmet_mobile.mov';
import video from '../../../../assets/artemis/helmet/artemis_helmet_mobile.webm';
import poster from '../../../../assets/artemis/helmet/artemis_helmet_mobile_poster.png';
import videomovD from '../../../../assets/artemis/helmet/artemis_helmet_desktop.mov';
import videoD from '../../../../assets/artemis/helmet/artemis_helmet_desktop.webm';
import posterD from '../../../../assets/artemis/helmet/artemis_helmet_desktop_poster.png';

function ArtemisHelmet({ screenWidth }) {
  // const artemisHelmetCanvas = useRef();
  const artemisHelmetSection = useRef();
  const artemisHelmetAnimation = useRef();
  // const images = useRef([]);
  // const ratio = useRef();
  const videoMRef = useRef();
  const videoDRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.6) {
              screenWidth > 480 ? videoDRef.current.play() : videoMRef.current.play();
            }
          }
        });
      },
      { threshold: [0, 0.6] }
    );
    observer.observe(artemisHelmetAnimation.current);
  }, [screenWidth]);

  // useEffect(() => {
  //   ratio.current = screenWidth > 480 ? 1.2 : 1.777;
  //   images.current = [];
  //   // set canvas properties
  //   const canvas = artemisHelmetCanvas.current.getContext('2d');
  //   // Set the size of the canvas
  //   artemisHelmetCanvas.current.width =
  //     screenWidth > 480 ? Math.min(window.innerWidth * 0.3, 492) : window.innerWidth;
  //   artemisHelmetCanvas.current.height = artemisHelmetCanvas.current.width * ratio.current;

  //   // Count the frames and set the path to the images
  //   const frameCount = 46;
  //   const currentFrame = (index, screenSize) =>
  //     `https://morgan-stanley-creating-space-cdn.s3.amazonaws.com/artemis/helmet/${screenSize}/XEMU_HELMET${(
  //       index + 1
  //     )
  //       .toString()
  //       .padStart(2, '0')}.png`;
  //   // Set start frame

  //   const target = {
  //     frame: 0
  //   };

  //   // Go through frames from start to finish
  //   const anim = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: artemisHelmetAnimation.current,
  //       start: 'top 70%',
  //       // endTrigger: artemisHelmetSection.current,
  //       // end: 'bottom bottom',
  //       scrub: 1
  //     }
  //   });

  //   if (screenWidth < 481) {
  //     for (let i = 0; i < frameCount; i++) {
  //       const img = new Image();
  //       img.src = currentFrame(i, 'mobile');
  //       images.current.push(img);
  //     }
  //   } else {
  //     for (let i = 0; i < frameCount; i++) {
  //       const img = new Image();
  //       img.src = currentFrame(i, 'desktop');
  //       images.current.push(img);
  //     }
  //   }

  //   anim.add('start').to(
  //     target,
  //     {
  //       frame: frameCount - 1,
  //       snap: 'frame',
  //       duration: 5,
  //       ease: 'linear',
  //       onUpdate: () => {
  //         render();
  //       }
  //     },
  //     'start'
  //   );

  //   images.current[0].onload = render;

  //   function render() {
  //     canvas.clearRect(0, 0, artemisHelmetCanvas.current.width, artemisHelmetCanvas.current.height);
  //     canvas.drawImage(
  //       images.current[target.frame],
  //       0,
  //       0,
  //       artemisHelmetCanvas.current.width,
  //       artemisHelmetCanvas.current.height
  //     );
  //   }
  // }, [screenWidth, images]);

  return (
    <section className="helmet helmet-artemis" ref={artemisHelmetSection}>
      <div className="helmet__upper helmet__upper-artemis">
        <h3 className="helmet__title helmet__title-artemis">
          According to NASA’s design requirements, the next Artemis suit must be able to fit
          everyone from a 5th percentile woman to a 95th percentile man.
        </h3>
      </div>
      <div className="helmet__lower helmet__lower-artemis">
        <div className="helmet__animation helmet__animation-artemis" ref={artemisHelmetAnimation}>
          {/* <canvas className="helmet__animation__canvas" ref={artemisHelmetCanvas} /> */}
          {screenWidth > 480 ? (
            <video
              muted
              playsInline
              preload="auto"
              ref={videoDRef}
              className="video"
              poster={posterD}
            >
              <source src={videomovD} type="video/quicktime" />
              <source src={videoD} type="video/webm" />
            </video>
          ) : (
            <video
              muted
              playsInline
              preload="auto"
              ref={videoMRef}
              className="video"
              poster={poster}
            >
              <source src={videomov} type="video/quicktime" />
              <source src={video} type="video/webm" />
            </video>
          )}
        </div>
        <div className="helmet__lower__text helmet__lower__text-artemis">
          <h3 className="helmet__lower__text__title helmet__lower__text__title-artemis">
            Visibility-Focused Helmet Shape
          </h3>
          <p className="helmet__lower__text__copy helmet__lower__text__copy-artemis">
            The xEMU prototype helmet’s shape allows for better downward visibility, so moonwalkers
            can see where they're going.
          </p>
        </div>
      </div>
    </section>
  );
}

export default ArtemisHelmet;
